import { render } from "./Edit.pug?vue&type=template&id=b27d1888&ts=true&lang=pug&external"
import script from "./Edit.ts?vue&type=script&lang=ts&external"
export * from "./Edit.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contacts/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b27d1888"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b27d1888', __exports__)) {
    api.reload('b27d1888', __exports__)
  }
  
  module.hot.accept("./Edit.pug?vue&type=template&id=b27d1888&ts=true&lang=pug&external", () => {
    api.rerender('b27d1888', render)
  })

}


export default __exports__